//jQuery mCustomScrollBar Helper function
//plugin-docs: http://manos.malihu.gr/jquery-custom-content-scroller
//example: dillardsApp.scrollbar(.wl-filter);
export const scrollbar = (elm) => {
    if ($(elm).length > 0) {
        $(window).load(function() {
            $(elm).mCustomScrollbar({
                theme: "dark-3",
                scrollInertia: 100
            });
            return false;
        });
    }
};
